import { Spin, notification } from 'antd';
import React, { useEffect } from 'react';
import { useUserProfileQuery } from '../../features/auth/authApi';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
    const { data, isSuccess, isFetching, error } =
        useUserProfileQuery('userDetails');
    const { t } = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
        if (!isSuccess && !isFetching && error) {
            //     // Authentication credentials were not provided
            notification.error({
                message: t(error.status),
                description: t(error.data.detail),
            });
            navigate('/app');
        }
    }, [data, isSuccess, isFetching]);

    if (data && Object.keys(data).length !== 0 && isSuccess) {
        return children;
    } else if (isFetching) {
        return (
            <div
                style={{
                    margin: 0,
                    width: '100%',
                    textAlign: 'center',
                    marginTop: '40vh',
                }}
            >
                <Spin size="large" />
            </div>
        );
    }
};
export default PrivateRoute;
